import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import PublicPaymentContainer from './PublicPaymentContainer';
import Layout from './Layout';
import OrgLoginContainer from './org/OrgLoginContainer';
import { useApiVersionCheck } from '../hooks/useApiVersionCheck';

const RouterContainer = (): JSX.Element => {
  useApiVersionCheck();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="pay/:merchantId/:invoiceId" element={<PublicPaymentContainer />} />
        <Route path="org/:orgId" element={<OrgLoginContainer />} />
        <Route path=":merchant/*" element={<Layout />}>
          <Route path="*" element={<AppRoutes />} />
        </Route>
        <Route path="*" element={<Navigate to="/:merchant/auth/login" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterContainer;
